export default [{
  name: "login",
  path: "/login",
  meta: {
    title: "用户登录",
  },
  component: () => import("./index.vue")
}];


// WEBPACK FOOTER //
// ./src/views/login/index.js